import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Lock, Eye, EyeSlash } from "@phosphor-icons/react";

export function PasswordInput({ testId, className = "", leftIcon = false, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      {leftIcon && <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />}
      <Input type={show ? "text" : "password"} data-testid={testId}
        className={`${leftIcon ? "pl-10 " : ""}pr-10 ${className}`} {...props} />
      <button type="button" onClick={() => setShow((s) => !s)} tabIndex={-1}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors">
        {show ? <EyeSlash size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
